import { IModule } from "app/IModule";
import BidsModule from "./bids/bids.module";

const features: IModule[] = [
    new BidsModule()
];

export default features;